import toast from "react-hot-toast";
import { cmsServices } from "../services/cms.service";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useDeleteCmsPage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: cmsServices.deleteCmsPage,
    onSuccess: () => {
      queryClient.invalidateQueries(["cmsPages"]);
      toast.success("CMS page deleted successfully");
    },
    onError: (error) => {
      toast.error(
        error?.response?.data?.message || "Failed to delete CMS page"
      );
    },
  });
};